<script>
import { ref, onMounted } from 'vue';
import { useStampAnimation } from './useStampAnimation';

/**
 * 1帯セル (StampCell)。
 *
 * Props:
 *   - acquired: bool 既に取得済みなら true (赤スタンプ overlay)
 *   - isNew: bool 当該セルが新規取得 (= マウント時に落下アニメ実行)
 *   - label: string 帯ラベル (slot1/2/3 や 時刻表記)
 */
export default {
    name: 'StampCell',
    props: {
        acquired: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
        label: { type: String, default: '' },
        ajisaiImageUrl: { type: String, default: '' },
    },
    setup(props) {
        const activeStyleRef = ref('');
        const animate = useStampAnimation(activeStyleRef);

        onMounted(async () => {
            if (props.isNew && props.acquired) {
                await animate();
            }
        });

        return { activeStyleRef };
    },
};
</script>

<template>
    <div class="stamp-cell" :class="{ acquired }">
        <div v-if="label" class="stamp-cell-label">{{ label }}</div>
        <div v-if="acquired" class="overlay-get" :style="isNew ? activeStyleRef : ''">
            <img v-if="ajisaiImageUrl" :src="ajisaiImageUrl" alt="獲得" class="stamp-image">
            <div v-else class="inner">獲得</div>
        </div>
        <div v-else class="stamp-cell-empty">○</div>
    </div>
</template>

<style scoped>
.stamp-cell {
    position: relative;
    width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2px;
}
.stamp-cell.acquired {
    background: #fff;
}
.stamp-cell-label {
    position: absolute;
    top: 2px;
    left: 4px;
    font-size: 9px;
    color: #888;
}
.stamp-cell-empty {
    color: #ccc;
    font-size: 24px;
}
.overlay-get {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}
.overlay-get .inner {
    font-size: 18px;
    font-weight: 900;
    color: #f00;
    border: 2px solid #f00;
    padding: 2px 6px;
    border-radius: 4px;
    transform: rotate(-10deg);
    background: rgba(0, 0, 0, 0.4);
    line-height: 1;
}
.overlay-get .stamp-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}
</style>
